var _path, _path2, _path3, _line, _line2, _path4;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGeneralError(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 198,
    height: 160,
    viewBox: "0 0 198 160",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.9162 137.142C96.0316 141.365 157.297 127.422 158.377 109.004C159.449 90.7214 118.986 70.9852 83 64C39.6476 55.5876 3.0001 51.5 1.00009 64",
    stroke: "black",
    strokeWidth: 0.375098,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M193.11 56.8116C195 32.0438 110 6.04379 39.9997 22.0438",
    stroke: "black",
    strokeWidth: 0.375098,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M88.5911 1.10583C82.1895 -0.609473 75.6095 3.18952 73.8942 9.59111L41.5418 130.332C39.8265 136.733 43.6255 143.313 50.0271 145.029L104.119 159.523C110.521 161.238 117.101 157.439 118.816 151.037L151.168 30.2966C152.884 23.895 149.085 17.315 142.683 15.5997L88.5911 1.10583ZM131.961 12.7268L132.809 12.954L132.809 12.954C132.349 12.8308 131.877 13.0971 131.74 13.5509L131.961 12.7268ZM98.4648 3.75155L99.3128 3.97877L99.3128 3.97879L131.961 12.7267L131.219 15.4939C130.626 17.7061 128.353 19.019 126.14 18.4262L101.503 11.8248C99.2911 11.232 97.9783 8.95809 98.571 6.74584L99.0857 4.82528L99.0508 4.81594C99.0543 4.80482 99.0575 4.79359 99.0606 4.78223C99.1808 4.33359 98.9141 3.87228 98.4648 3.75164L98.4648 3.75155Z",
    fill: "#F44719"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 83.7321,
    y1: 58,
    x2: 108.423,
    y2: 100.767,
    stroke: "#005B4B",
    strokeWidth: 4
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 74.9385,
    y1: 91.7945,
    x2: 117.705,
    y2: 67.1031,
    stroke: "#005B4B",
    strokeWidth: 4
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M1.00006 63.9684C-0.501503 76.2613 63.2277 79.6762 86.8736 80.7867C113.107 82.0187 190.474 82.1327 193.1 57",
    stroke: "black",
    strokeWidth: 0.375098,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGeneralError);
export default __webpack_public_path__ + "static/media/general_error.c1319b9933966463a0e3d5e5c550b515.svg";
export { ForwardRef as ReactComponent };